import { createHead } from '@unhead/vue/client'
import i18n from './i18n'

const unhead = createHead({
  init: [
    {
      titleTemplate: (title) => (title ? `${title} | Amili` : 'Amili'),
      htmlAttrs: {
        lang: () => i18n.global.locale.value,
      },
    },
  ],
})

export default unhead
